/* 
    Author: Andrej Stjepanovic
    Info: This helper is used if you are using list builder without context
*/
export function parseJSON(response) {
	return response.json().then((json) => {
		return {
			result: json,
			status: response.status,
		};
	});
}

export function getParamsFromURL(defaults = { entries: 10, filter: '' }) {
	const urlParams = new URLSearchParams(window.location.search);
	return {
		entries: parseInt(urlParams.get('entries')) || defaults.entries,
		filter: urlParams.get('filter') || defaults.filter,
	};
}

export function updateURLParams(params) {
	const { entries, filter } = params;
	const url = new URL(window.location);

	url.searchParams.set('entries', entries);
	if (filter) url.searchParams.set('filter', filter);
	else url.searchParams.delete('filter');

	window.history.pushState({}, '', url);
}

export function updateParamsHelper(component, fields, options = {}) {
	const {
		restart = false,
		updateUrl = true,
		refreshFnName = 'get',
		defaults = { entries: 10, page: 0, filter: '' },
	} = options;

	let newParams = restart ? { ...defaults } : { ...component.state.params };

	if (Array.isArray(fields)) {
		fields.forEach((f) => {
			newParams[f.name] = f.value;
		});
	} else if (typeof fields === 'object') {
		Object.entries(fields).forEach(([key, value]) => {
			newParams[key] = value;
		});
	}

	component.setState({ params: newParams }, () => {
		if (updateUrl) updateURLParams(newParams);
		component[refreshFnName]?.();
	});
}
